import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import ITTrainingHeader from '../../components/ITTrainingHeader';
import ITTrainingFooter from '../../components/ITTrainingFooter';

const courses = [
  'Python Training', 'Python With AI', 'Python With ML', 'Machine Learning',
  'Android Training', 'Android With IoT', 'IoT Training', 'iPhone Training',
  'PHP/MySQL Training', 'ASP.Net Training', 'Java Training', 'Odoo Training',
  'Big Data Training', 'Hadoop Training', 'WordPress Training', 'Magento Training',
  'CodeIgniter Training', 'Drupal Training', 'Software Testing', 'Digital Marketing',
  'Web Design Training', 'Graphics Design Training', 'SEO Training',
  'Business Development Training', 'Free Training', 'Weekend Training', 'Corporate Training',
  'Other / Not Sure',
];

const infoCards = [
  {
    icon: '📍',
    title: 'Our Location',
    lines: ['Vedanskrix Web LLP', 'Ahmedabad, Gujarat, India'],
  },
  {
    icon: '📞',
    title: 'Call Us',
    lines: ['+91 87586 37022'],
  },
  {
    icon: '✉️',
    title: 'Email Us',
    lines: ['vedanskrix@gmail.com'],
  },
  {
    icon: '🕒',
    title: 'Working Hours',
    lines: ['Mon – Sat: 9:00 AM – 7:00 PM', 'Sunday: By Appointment'],
  },
];

function ITContact() {
  const [form, setForm] = useState({
    name: '', phone: '', email: '', course: '', message: '', mode: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="itp-shell">
      <Seo
        title="Contact IT Training | Vedanskrix Ahmedabad"
        description="Contact Vedanskrix for IT training inquiries. Reach out for Python, Java, PHP, Android courses and job placement assistance in Ahmedabad."
        keywords={['contact IT training','enquire IT course','Vedanskrix contact','IT training inquiry','course admission contact','call IT training centre']}
      />
      <ITTrainingHeader />

      {/* Hero */}
      <section className="itpage-hero itpage-hero--contact">
        <div className="itpage-hero__overlay" />
        <div className="itp-container itpage-hero__content">
          <p className="itpage-hero__eyebrow">Vedanskrix IT Training</p>
          <h1 className="itpage-hero__title">Contact Us</h1>
          <p className="itpage-hero__sub">Get in touch — our counsellors are ready to help you choose the right course</p>
          <div className="itpage-hero__crumb">
            <Link to="/">Home</Link>
            <span> › </span>
            <span>Contact Us</span>
          </div>
        </div>
      </section>

      {/* Info Cards */}
      <section className="itcontact-info-row">
        <div className="itp-container">
          <div className="itcontact-info-grid">
            {infoCards.map(card => (
              <div key={card.title} className="itcontact-info-card">
                <span className="itcontact-info-card__icon">{card.icon}</span>
                <h4 className="itcontact-info-card__title">{card.title}</h4>
                {card.lines.map(l => <p key={l} className="itcontact-info-card__line">{l}</p>)}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="itpage-section">
        <div className="itp-container">
          <div className="itcontact-main">

            {/* Enquiry Form */}
            <div className="itcontact-form-wrap">
              <h2 className="itcontact-form-title">Quick Enquiry</h2>
              <p className="itcontact-form-sub">Fill in the form and we'll get back to you within 24 hours.</p>

              {submitted ? (
                <div className="itcontact-success">
                  <span className="itcontact-success__icon">✅</span>
                  <h3>Thank you, {form.name || 'there'}!</h3>
                  <p>We've received your enquiry and will contact you shortly on <strong>{form.phone || form.email}</strong>.</p>
                  <button
                    type="button"
                    className="itpage-cta-strip__btn"
                    style={{marginTop: '16px', display: 'inline-block'}}
                    onClick={() => setSubmitted(false)}
                  >
                    Submit Another Enquiry
                  </button>
                </div>
              ) : (
                <form className="itcontact-form" onSubmit={handleSubmit}>
                  <div className="itcontact-form__row">
                    <div className="itcontact-form__group">
                      <label htmlFor="itc-name">Full Name *</label>
                      <input
                        id="itc-name" name="name" type="text" required
                        placeholder="Your full name"
                        value={form.name} onChange={handleChange}
                      />
                    </div>
                    <div className="itcontact-form__group">
                      <label htmlFor="itc-phone">Phone Number *</label>
                      <input
                        id="itc-phone" name="phone" type="tel" required
                        placeholder="+91 XXXXX XXXXX"
                        value={form.phone} onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="itcontact-form__group">
                    <label htmlFor="itc-email">Email Address</label>
                    <input
                      id="itc-email" name="email" type="email"
                      placeholder="you@example.com"
                      value={form.email} onChange={handleChange}
                    />
                  </div>
                  <div className="itcontact-form__row">
                    <div className="itcontact-form__group">
                      <label htmlFor="itc-course">Course Interested In *</label>
                      <select id="itc-course" name="course" required value={form.course} onChange={handleChange}>
                        <option value="">— Select a course —</option>
                        {courses.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="itcontact-form__group">
                      <label htmlFor="itc-mode">Preferred Mode</label>
                      <select id="itc-mode" name="mode" value={form.mode} onChange={handleChange}>
                        <option value="">— Select mode —</option>
                        <option value="offline">Offline (Ahmedabad)</option>
                        <option value="online">Online</option>
                        <option value="weekend">Weekend Batch</option>
                      </select>
                    </div>
                  </div>
                  <div className="itcontact-form__group">
                    <label htmlFor="itc-message">Message / Questions</label>
                    <textarea
                      id="itc-message" name="message" rows="4"
                      placeholder="Tell us about your background and goals..."
                      value={form.message} onChange={handleChange}
                    />
                  </div>
                  <button type="submit" className="itcontact-form__submit">
                    Send Enquiry →
                  </button>
                </form>
              )}
            </div>

            {/* Map Placeholder */}
            <div className="itcontact-map-wrap">
              <h2 className="itcontact-form-title">Find Us</h2>
              <p className="itcontact-form-sub">Visit our Ahmedabad training centre for a free demo class.</p>
              <div className="itcontact-map-box">
                <div className="itcontact-map-placeholder">
                  <span className="itcontact-map-pin">📍</span>
                  <p className="itcontact-map-label">Vedanskrix Web LLP</p>
                  <p className="itcontact-map-addr">Ahmedabad, Gujarat, India</p>
                  <a
                    href="https://maps.google.com/?q=Vedanskrix+Web+LLP+Ahmedabad"
                    target="_blank"
                    rel="noreferrer"
                    className="itcontact-map-link"
                  >
                    Open in Google Maps →
                  </a>
                </div>
              </div>

              {/* Social Quick Links */}
              <div className="itcontact-socials">
                <h4>Connect with Us</h4>
                <div className="itcontact-socials__row">
                  <a href="https://wa.me/918758637022" target="_blank" rel="noreferrer" className="itcontact-social-btn itcontact-social-btn--wa">
                    💬 WhatsApp
                  </a>
                  <a href="#" className="itcontact-social-btn itcontact-social-btn--fb" onClick={e => e.preventDefault()}>
                    Facebook
                  </a>
                  <a href="#" className="itcontact-social-btn itcontact-social-btn--yt" onClick={e => e.preventDefault()}>
                    YouTube
                  </a>
                  <a href="#" className="itcontact-social-btn itcontact-social-btn--li" onClick={e => e.preventDefault()}>
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="itpage-section itpage-section--alt">
        <div className="itp-container">
          <div className="itpage-section-head">
            <h2 className="itpage-section-title">Frequently Asked Questions</h2>
          </div>
          <div className="itcontact-faq-grid">
            {[
              { q: 'Do you offer demo classes?', a: 'Yes! We offer a free demo class for all our courses. Contact us to schedule yours.' },
              { q: 'Are classes available online?', a: 'Yes. We offer both offline (Ahmedabad) and online training options.' },
              { q: 'What is the course fee structure?', a: 'Fees vary by course. Contact us for a detailed fee breakdown and any current discounts.' },
              { q: 'Is placement assistance guaranteed?', a: 'We provide dedicated placement support including resume preparation, mock interviews, and job referrals.' },
              { q: 'Do you provide a certificate?', a: 'Yes, all students receive a certificate of completion upon successfully finishing the course.' },
              { q: 'Can I pay fees in instalments?', a: 'Yes, we offer flexible instalment plans. Discuss your preference with our counsellors.' },
            ].map(item => (
              <div key={item.q} className="itcontact-faq-card">
                <h4 className="itcontact-faq-q">❓ {item.q}</h4>
                <p className="itcontact-faq-a">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ITTrainingFooter />
    </div>
  );
}

export default ITContact;
